import { Button, Row, Slider } from '@microfrontends/react-components'
import Image from 'next/image'
import { useContext, useEffect, useState } from 'react'
import AppContext from '../../context/AppContext'
import ChevronRightIcon from '../Icons/CevronRightIcon'
import { isMobile } from '../utils'
import {
	MostUsageCVWrapper,
	MostUsageTitle,
	CVPreview,
	ButtonWrapper,
	ViewAllButton} from './MostUsageCV.css'

const APP_MODE = process.env.APP_SHELL_MODE
const WOW_CV_PATH = `https://${
	APP_MODE !== 'production' ? `${APP_MODE}` : 'www'
}.vietnamworks.com/assets-new-wowcv-container`

const MostUsageCV = () => {
	const { t } = useContext(AppContext)
	const [wowCVUrl, setWowCVUrl] = useState<string>(
		'https://www.vietnamworks.com/wowcv'
	)

	const cvImageUrls = [
		{
			name: 'CV 26',
			cvIndex: 26,
			url: `${WOW_CV_PATH}/images/list_templates/cv_template_26_thumb.png`
		},
		{
			name: 'CV 25',
			cvIndex: 25,
			url: `${WOW_CV_PATH}/images/list_templates/cv_template_25_thumb.png`
		},
		{
			name: 'CV 24',
			cvIndex: 24,
			url: `${WOW_CV_PATH}/images/list_templates/cv_template_24_thumb.png`
		},
		{
			name: 'CV 23',
			cvIndex: 23,
			url: `${WOW_CV_PATH}/images/list_templates/cv_template_23_thumb.png`
		},
		{
			name: 'CV 22',
			cvIndex: 22,
			url: `${WOW_CV_PATH}/images/list_templates/cv_template_22_thumb.png`
		},
		{
			name: 'CV 20',
			cvIndex: 20,
			url: `${WOW_CV_PATH}/images/list_templates/cv_template_20_thumb.png`
		},
		{
			name: 'CV 19',
			cvIndex: 19,
			url: `${WOW_CV_PATH}/images/list_templates/cv_template_19_thumb.png`
		}
	]

	const getWowCVLink = () => {
        return typeof window === 'undefined' ? 'https://www.vietnamworks.com' : (window.location.origin)
    }

	const onClickView = (e: React.MouseEvent, url: string) => {
		e.preventDefault()
		if (typeof window === 'undefined') {
			return
		}
		// if (!user?.accessToken || user?.accessToken === '') {
		// 	showLoginModal(languageCode || ELanguage.VI)
		// 	return
		// }
		window.location.assign(url)
	}

	useEffect(() => {
		if (typeof window === 'undefined') {
			return
		}

		setWowCVUrl(getWowCVLink())
	}, [])

	return (
		<div>
			<Row align='middle' justify='space-between'>
				<MostUsageTitle>
					{t('CV do VietnamWorks đề xuất')}
				</MostUsageTitle>
				{!isMobile() ? (
					<ViewAllButton xs={12}>
						<a
							href={`${wowCVUrl}/${t(
								'cv-template'
							)}?templateId=21&cache=disable`}
						>
							{t('Xem tất cả')}{' '}
							<ChevronRightIcon color='#005aff' />
						</a>
					</ViewAllButton>
				) : null}
			</Row>
			<MostUsageCVWrapper>
				<Slider
					id='cv-preview-item'
					slides={{ elementPerView: !isMobile() ? 4 : 1 }}
					transitionTime={500}
					pagination={{ maxShow: 3 }}
				>
					{cvImageUrls.map((cvUrl, index) => {
						const wowcvUrl = `${wowCVUrl}/${t(
							'cv-template'
						)}?templateId=${cvUrl.cvIndex}&cache=disable`
						return (
							<CVPreview
								key={`cv-preview-${index}`}
								href={wowcvUrl}
							>
								<Image
									src={cvUrl.url}
									alt={cvUrl.name}
									layout='fill'
								/>
								<ButtonWrapper>
									<Button
										type='primary'
										onClick={(e) => onClickView(e, wowcvUrl)}
									>
										{t('Xem trước')}
									</Button>
								</ButtonWrapper>
							</CVPreview>
						)
					})}
				</Slider>
				{isMobile() ? (
					<ViewAllButton xs={24}>
						<a
							href={`${wowCVUrl}/${t(
								'cv-template'
							)}?templateId=21&cache=disable`}
						>
							{t('Xem tất cả')}{' '}
							<ChevronRightIcon color='#005aff' />
						</a>
					</ViewAllButton>
				) : null}
			</MostUsageCVWrapper>
		</div>
	)
}

export default MostUsageCV
